import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class AuditLogService {
  private readonly http = inject(HttpClient);

  login(userEmail: string) {
    let url = `${environment.baseUrl}/auditlog/ingest`;
    this.http
      .post(
        url,
        { userEmail, operationType: 'LOGGED_IN' },
        { responseType: 'text' }
      )
      .subscribe();
  }

  appLoaded(userEmail: string) {
    let url = `${environment.baseUrl}/auditlog/ingest`;
    this.http
      .post(
        url,
        { userEmail, operationType: 'APP_LOADED' },
        { responseType: 'text' }
      )
      .subscribe();
  }

  logout(userEmail: string) {
    let url = `${environment.baseUrl}/auditlog/ingest`;
    this.http
      .post(
        url,
        { userEmail, operationType: 'LOGGED_OUT' },
        { responseType: 'text' }
      )
      .subscribe();
  }
}
